import {
  CreatePaylinkHookByApiKeyDto,
  CreatePaylinkHookDto,
  PaylinkHook,
} from '@heliofi/common';
import { ApiAdapter } from '../../ApiAdapter';

export class PaylinkWebhookSDK {
  private readonly apiAdapter: ApiAdapter;

  constructor(apiAdapter: ApiAdapter) {
    this.apiAdapter = apiAdapter;
  }

  async createPaylinkWebhook(
    payload: CreatePaylinkHookByApiKeyDto,
  ): Promise<PaylinkHook> {
    return this.apiAdapter.post(
      '/webhook/paylink/api-key',
      payload,
      'Failed to create paylink webhook',
    );
  }
}
